import { Link } from 'react-router-dom';

import { useRuns } from '../hooks/use-runs';

export function RunsPage() {
  const { data, isLoading, error } = useRuns(100);

  return (
    <div className="page">
      <header className="page-head">
        <Link to="/" className="link">
          ← Composer
        </Link>
        <h1>Recent runs</h1>
      </header>
      {isLoading ? <div className="muted">Loading…</div> : null}
      {error ? <div className="error">{error.message}</div> : null}
      {data ? (
        <table className="runs-table">
          <thead>
            <tr>
              <th>When</th>
              <th>User</th>
              <th>Status</th>
              <th>Platforms</th>
              <th>Articles</th>
              <th>Countries</th>
              <th>Trigger</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {data.map((row) => (
              <tr key={row.id}>
                <td className="mono dim">
                  {new Date(row.created_at).toLocaleString()}
                </td>
                <td>{row.test_user_email.replace('@newswave.test', '')}</td>
                <td>
                  <span className={`pill pill-${row.status}`}>
                    {row.status}
                  </span>
                </td>
                <td className="dim">{row.platforms.join(', ')}</td>
                <td className="dim">{row.article_ids.length}</td>
                <td className="dim">{row.countries.join(', ')}</td>
                <td className="dim">{row.trigger}</td>
                <td>
                  <Link to={`/runs/${row.id}`} className="link">
                    open
                  </Link>
                </td>
              </tr>
            ))}
            {data.length === 0 ? (
              <tr>
                <td colSpan={8} className="muted">
                  No runs yet. Render a carousel from the composer.
                </td>
              </tr>
            ) : null}
          </tbody>
        </table>
      ) : null}
    </div>
  );
}
